import React, { useState } from 'react';
import { Icon } from '@tencent/spaui';
import { deleteData } from 'store/request';
import { hideDialog, showDialog } from 'components/dialog';
import { useTypedSelector } from 'store/index';

// eslint-disable-next-line react/display-name
export default (props: { client_id: string; onFinish: () => void; className?: string }): JSX.Element => {
  const [unbinding, setUnbindig] = useState<boolean>(false);
  const [didBind, setDidBind] = useState<boolean>(false);
  const {
    user: { user },
  } = useTypedSelector((state) => state);
  const { client_id, onFinish, className } = props;
  const { user_id } = user;
  const unbind = (): void => {
    if (unbinding) {
      return;
    }
    setUnbindig(true);
    deleteData(`/user_client_bind/delete?user_id=${user_id}&client_id=${client_id}`, { client_id, user_id })
      .then(() => {
        showDialog({
          className: 'auth-success',
          content: (
            <>
              <Icon name="check-filled" />
              <div className="text-bold">解绑应用成功！</div>
              <span className="rect-button light" role="button" onClick={() => hideDialog()}>
                完成
              </span>
            </>
          ),
        });
        setDidBind(true);
        onFinish();
      })
      .catch(() => {})
      .finally(() => setUnbindig(false));
  };
  if (didBind) {
    return <></>;
  }

  return (
    <span className={className} role="button" onClickCapture={() => unbind()}>
      解绑应用
    </span>
  );
};
